import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { nextjsPlugin, onRouterTransitionStart } from "@datadog/browser-rum-nextjs";
import { isPublicSandboxAuthEnabled } from "./lib/auth/sandbox";
import { applyDatadogUserIdentity } from "./lib/observability/apply-datadog-user";
import {
  getDatadogEnv,
  getDatadogReleaseVersion,
  getDatadogSite,
  isEnvFlagEnabled,
  parseSampleRate,
} from "./lib/observability/datadog-env";
import { resolveDatadogUserIdentityFromCookieHeader } from "./lib/observability/datadog-user-cookie";

export { onRouterTransitionStart };

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

if (applicationId && clientToken) {
  const site = getDatadogSite(process.env.NEXT_PUBLIC_DATADOG_SITE);
  const service = process.env.NEXT_PUBLIC_DATADOG_SERVICE || "tcos-core";
  const env = getDatadogEnv({
    explicit: process.env.NEXT_PUBLIC_DATADOG_ENV,
    vercelEnv: process.env.NEXT_PUBLIC_VERCEL_ENV,
    gitRef: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF,
  });
  const version = getDatadogReleaseVersion();

  datadogLogs.init({
    clientToken,
    site,
    service,
    env,
    version,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error"],
    sessionSampleRate: 100,
  });

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service,
    env,
    version,
    sessionSampleRate: parseSampleRate(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE, 100),
    sessionReplaySampleRate: parseSampleRate(
      process.env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_SAMPLE_RATE,
      20
    ),
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [window.location.origin],
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: isEnvFlagEnabled(
      process.env.NEXT_PUBLIC_DATADOG_TRACK_USER_INTERACTIONS,
      true
    ),
    plugins: [nextjsPlugin()],
  });

  // Identify before DatadogAppRouter starts the first view so the session event
  // itself has usr.id. Later auth changes are applied by DatadogUserContext.
  if (!isPublicSandboxAuthEnabled()) {
    applyDatadogUserIdentity(resolveDatadogUserIdentityFromCookieHeader(document.cookie));
  }
}
